import {
  Flex,
  FlexItem,
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputNumber,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_STANDARD
} from 'mailup-web-components'
import { step2State } from 'Pages/Workflow/recoil/state/step2'

import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const StartTypeSubscription = () => {
  const intl = useIntl()

  const { ActivityValue } = useRecoilValue(step2State)

  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const handleChangeActivityValue = (value) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      ActivityValue: value
    }))
  }

  const activityValueIsValid =
    ActivityValue !== null && ActivityValue >= 0 && ActivityValue <= 999

  const wrongFormatFeedback = intl.formatMessage(
    {
      id: 'Load.AutomationWorkflow.LastDayValidation'
    },
    {
      XGIORNI: 999
    }
  )

  return (
    <>
      <Flex
        justifyContent='flex-start'
        alignItems='flex-start'
        columnGap='16px'
      >
        <FormElement
          feedback={!activityValueIsValid ? wrongFormatFeedback : undefined}
          feedbackVariant={!activityValueIsValid ? 'danger' : undefined}
        >
          <Flex columnGap='16px'>
            <FlexItem margin='8px 0 0 0'>
              <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.EventTimeTile'
                })}
              </Text>
            </FlexItem>
            <Flex display='block' width='75px'>
              <InputNumber
                value={ActivityValue}
                onChange={handleChangeActivityValue}
                variant={
                  !activityValueIsValid ? INPUT_TEXT_VARIANT_DANGER : undefined
                }
                min={0}
                max={999}
                step={1}
              />
            </Flex>
            <FlexItem margin='8px 0 0 0'>
              <Text variant={TEXT_VARIANT_STANDARD} htmlElement='span'>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.EventTimeDayAfter'
                })}
              </Text>
            </FlexItem>
          </Flex>
        </FormElement>
      </Flex>
    </>
  )
}

export default StartTypeSubscription
